import { render, staticRenderFns } from "./TournamentHolding.vue?vue&type=template&id=04a7fff6&lang=pug"
import script from "./TournamentHolding.vue?vue&type=script&lang=js"
export * from "./TournamentHolding.vue?vue&type=script&lang=js"
import style0 from "./TournamentHolding.vue?vue&type=style&index=0&id=04a7fff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports